module.exports = __webpack_public_path__ + "62617c4d5e87a5d01cb20e112ea27859.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/new-design/icons/amex.svg
// module id = 1272
// module chunks = 73